import styled from "@emotion/styled";

export const Wrapper = styled.div`
  flex-grow: 1;

  padding: ${p => p.theme.space[6]}px;
  background-color: ${({ theme }) => theme.colors.white};

  border-radius: ${({ theme }) => theme.radii.normal};
`;

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${({ showMore, theme }) => (showMore ? theme.space[5] : 0)}px;
  transition: margin-bottom 0.3s ease-in-out;
`;

export const Title = styled.p`
  font-size: 20px;
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${p => p.theme.colors.black};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.xl};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  background-color: ${p => p.theme.colors.black};

  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const Icon = styled.img`
  transition: transform 0.3s ease-in-out;

  transform: ${p => (p.open ? "rotate(0deg)" : "rotate(180deg)")};
`;

export const ArticleList = styled.ul`
  max-height: ${p => (p.showMore ? "1000px" : "0")};
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;

  list-style: none;
`;
